import script from "./project-details.vue?vue&type=script&setup=true&lang=js"
export * from "./project-details.vue?vue&type=script&setup=true&lang=js"

import "./project-details.vue?vue&type=style&index=0&id=e0d1dda6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0d1dda6"]])

export default __exports__